import { usePrimeVue } from 'primevue/config'
import { dayNames, dayNamesMin, dayNamesShort, monthNamesShort, mounthNames } from '@/utils/config-locale'

export const usePrimeVueConfig = () => {
   const { config } = usePrimeVue()

   const defineLocale = () => {
      config.locale.monthNames = mounthNames
      config.locale.dayNames = dayNames
      config.locale.dayNamesShort = dayNamesShort
      config.locale.dayNamesMin = dayNamesMin
      config.locale.monthNamesShort = monthNamesShort
   }

   return {
      defineLocale
   }
}
